<template>
  <div class="container-fluid navigation-bar p-1 px-2">
    <button @click="toggle" class="burger">
      <font-awesome-icon icon="fa-solid fa-bars" />
    </button>

    <div class="navbar-logo"></div>
    <div class="navigation-box d-flex justify-content-center">
      <div class="d-flex flex-column" v-if="$store.getters.isTot">
        <img src="@/assets/img/caution.png" alt="Tot"
             style="background: black;border-radius: 10px;position: sticky;z-index: 100;margin-right: 50px"
             height="50px" width="50px">
      </div>
    </div>

    <div class="user-settings">
      <a class="burger float-start mx-3" v-if="showLoyalty" @click="checkLoyalty">
        <font-awesome-icon icon="heart-circle-check" v-if="!!$store.getters.getLoyaltyDetails.barcode"/>
        <font-awesome-icon icon="heart-circle-plus" v-else/>
      </a>
      <Notification/>
    </div>

    <div class="right-section">
      <button @click="syncData" class="refresh-btn">
        <font-awesome-icon icon="arrows-rotate"/>
      </button>
      <div class="device-mode">
        <font-awesome-icon v-if="isAndroid" :icon="['fas', 'mobile-screen']" class="device-icon" />
        <font-awesome-icon v-else :icon="['fas', 'desktop']" class="device-icon" />
        <span class="mode-text">{{ isAndroid ? 'Mobile' : 'Desktop' }} Mode</span>
      </div>
    </div>

    <custom-modal title="Add Loyalty Customer To Sale" ref="scanLoyalty" @open="focusInput">
      <div v-if="!loyaltyDetails.barcode">
        <label for="loyalty-barcode">Scan Barcode</label>
        <input type="text" class="form-control" :disabled="$store.getters.getLoadingState" id="loyalty-barcode"
               v-model="loyaltyBarcode" ref="loyaltyCode"
               @keyup.enter="validateBarcode">
      </div>
      <div class="d-flex flex-column" v-else>
        <span class="text-sm text-secondary">Barcode : {{ loyaltyDetails.barcode }}</span>
        <div class="d-flex flex-row">
          Customer : {{ loyaltyDetails.name }} {{ loyaltyDetails.surname }}
          <a class="btn btn-sm btn-outline-primary mx-2" @click="$store.commit(`setLoyaltyDetails`,{})">
            <font-awesome-icon icon="close"/>
          </a>
        </div>
        <span>Contact : {{ loyaltyDetails.contact }}</span>
        Points Value : {{ loyaltyDetails.balance }} points - ({{ $utils.formatMoney(loyaltyDetails.pointsInCash) }})
      </div>
    </custom-modal>
  </div>
</template>

<script>
import Notification from "@/components/layout/navigation/Notification";
import CustomModal from "@/components/layout/utils/CustomModal";

export default {
  name: "NavigationBar",
  components: { CustomModal, Notification },
  computed: {
    salesScreens() {
      return [`pos`, `payment`, `split-payment`, `instruction`];
    },
    showLoyalty() {
      let isSalesScreen = this.salesScreens.includes(this.$route.name);
      return this.$store.getters.getHasLoyalty && isSalesScreen;
    },
    loyaltyDetails() {
      return this.$store.getters.getLoyaltyDetails;
    },
    // Check if the device is Android
    isAndroid() {
      const isAndroidDevice = navigator.userAgent.toLowerCase().includes('android');
        return isAndroidDevice;
    }
  },
  data() {
    return {
      loyaltyBarcode: null,
    };
  },
  props: {
    toggle: {
      type: Function,
      required: true,
    },
  },
  methods: {
    syncData() {
      return window.location.reload(true);
    },
    tawkTo() {
      return window.open('https://tawk.to/LytSupport', '_self');
    },
    validateBarcode() {
      if (!isValidString(this.loyaltyBarcode)) return;
      this.$refs.scanLoyalty.closeModal();
      this.$utils.showLoading();
      return this.$store
          .dispatch(`checkLoyaltyBarcode`, this.loyaltyBarcode)
          .finally(() => {
            this.loyaltyBarcode = null;
            this.$refs.scanLoyalty.openModal();
          });
    },
    checkLoyalty() {
      return this.$refs.scanLoyalty.openModal();
    },
    async focusInput() {
      if (!!this.loyaltyDetails.barcode) return;
      await new Promise((resolve) => setTimeout(resolve, 1000));
      return this.$refs.loyaltyCode.focus();
    },
  },
};
</script>

<style lang="scss" scoped>
.container-fluid.navigation-bar {
  background: #0092f7;
  padding: 0.75rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 15px rgba(0, 146, 247, 0.25);
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.1) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    transform: rotate(30deg);
    animation: shine 8s infinite;
  }

  .burger {
    width: 40px;
    height: 40px;
    background: rgba(255, 255, 255, 0.15);
    color: white;
    font-size: 20px;
    border: none;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    backdrop-filter: blur(4px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    &:hover {
      background: rgba(255, 255, 255, 0.25);
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }

    &:active {
      transform: translateY(0);
    }
  }

  .navbar-logo {
    flex: 1;
    margin: 0 1rem;
  }

  .navigation-box {
    display: flex;
    align-items: center;
    gap: 1rem;

    img {
      transition: all 0.3s ease;
      &:hover {
        transform: scale(1.05);
      }
    }
  }

  .right-section {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-left: auto;
    padding-left: 16px;
    border-left: 1px solid rgba(255, 255, 255, 0.1);
  }

  .device-mode {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 16px;
    background: rgba(255, 255, 255, 0.08);
    border-radius: 20px;
    pointer-events: none;

    .device-icon {
      font-size: 18px;
      color: rgba(255, 255, 255, 0.9);
    }

    .mode-text {
      color: rgba(255, 255, 255, 0.9);
      font-size: 0.875rem;
      font-weight: 400;
      letter-spacing: 0.5px;
    }
  }

  .refresh-btn {
    width: 40px;
    height: 40px;
    background: rgba(255, 255, 255, 0.15);
    color: white;
    font-size: 20px;
    border: none;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    backdrop-filter: blur(4px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    position: relative;
    overflow: hidden;

    &::after {
      content: '';
      position: absolute;
      top: -50%;
      left: -50%;
      width: 200%;
      height: 200%;
      background: linear-gradient(
        to right,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.2) 50%,
        rgba(255, 255, 255, 0) 100%
      );
      transform: rotate(30deg);
      animation: shine 4s infinite;
    }

    &:hover {
      background: rgba(255, 255, 255, 0.25);
      transform: translateY(-2px) rotate(180deg);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }

    &:active {
      transform: translateY(0) rotate(180deg);
    }

    .icon {
      transition: transform 0.3s ease;
    }
  }

  .user-settings {
    display: flex;
    align-items: center;
    gap: 0.75rem;

    .burger {
      position: relative;
      
      &:hover {
        transform: translateY(-2px);
      }

      &.active {
        background: rgba(255, 255, 255, 0.25);
      }
    }
  }
}

@keyframes shine {
  0% {
    transform: translateX(-100%) rotate(30deg);
  }
  15%, 100% {
    transform: translateX(100%) rotate(30deg);
  }
}

// Update the modal styles
:deep(.modal-content) {
  border-radius: 16px;
  border: none;
  box-shadow: 0 8px 32px rgba(0, 146, 247, 0.15);
}

:deep(.form-control) {
  border-radius: 10px;
  border: 1px solid rgba(0, 146, 247, 0.2);
  padding: 0.75rem;
  transition: all 0.3s ease;

  &:focus {
    border-color: #0092f7;
    box-shadow: 0 0 0 3px rgba(0, 146, 247, 0.1);
  }
}

:deep(.btn-outline-primary) {
  border-radius: 10px;
  padding: 0.5rem 1rem;
  transition: all 0.3s ease;
  border-color: #0092f7;
  color: #0092f7;

  &:hover {
    transform: translateY(-2px);
    background: #0092f7;
    color: white;
    box-shadow: 0 4px 12px rgba(0, 146, 247, 0.2);
  }
}

.text-sm {
  font-size: 0.875rem;
  color: #6c757d;
}
</style>
